module.exports = __webpack_public_path__ + "img/global-2016-governance-forum.7303f3ce.jpg";